<template>
  <BasicTemplate>
    <h3>
      <router-link to="/games">Games</router-link> /
      Game new
    </h3>
    <GameForm :item="item" @save="save" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';
import GameForm from './form.vue';

export default {
  name: 'GameEdit',
  components: { BasicTemplate, GameForm },
  data() {
    return {
      item: {
        hasCollection: false,
        hasEagle: false,
        hasGems: false,
        isAdsFree: false,
        isFlex: true,
        isGRM: true,
        isIframe: true,
        hasFullscreen: false,
        hasComingSoon: false,
        hasLeaderboard: false,
        isSubscriberOnly: false,
        hasAuth: false,
        hasPlatformGameEnd: false,
        hasInventory: false,
        hasCloudSave: false,
        cloudSaveStorage: null,
        hasMultiplayer: false,
        hasInterstitialAds: false,
        hasRewardedAds: false,
        hasPortraitMode: false,
        adPodding: false,
        tier: null,
        engineVersion: null,
        sdk: null,
        liveOpsDependencies: null,
        mtxDetails: null,
        renderingType: 'Html',
      },
    };
  },
  async created() {
    // Check authentication status
    if (!this.msal?.idToken) {
      console.error('No authentication token found!');
      this.$swal.fire({ 
        icon: 'error', 
        title: 'Authentication required', 
        text: 'Please log in to create a game',
        timer: 3000, 
        showConfirmButton: false 
      });
      return;
    }
  },
  methods: {
    async save(gameData) {
      // Update the item with form data
      Object.assign(this.item, gameData);
      
      try {
        const item = await this.$gameApi.post(`/games`, this.item);
        this.$swal.fire({ icon: 'success', title: 'Game saved.', timer: 1500, showConfirmButton: false });
        this.$router.push(`/games/${item.id}`);
      } catch (e) {
        console.error('Error saving game:', e);
        this.$swal.fire({ icon: 'error', title: e.message || 'Error saving game', timer: 1500, showConfirmButton: false });
      }
    }
  }
};
</script>

